import { lazy, Suspense, useEffect } from 'react'
import { Layout } from './components'
import { usePublishedProjects } from './hooks'
import { About, Contact, Home, NotFound, Privacy, Projects, Services } from './pages'
import { usePath } from './router'

const OwnerPortal = lazy(() => import('./owner/OwnerPortal'))
const titles: Record<string, string> = { '/': 'Manawatu Engineering | Fabrication, Repairs & Mobile Welding', '/services': 'Engineering Services | Manawatu Engineering', '/about': 'About | Manawatu Engineering', '/contact': 'Contact Anthony | Manawatu Engineering', '/projects': 'Projects | Manawatu Engineering', '/privacy': 'Privacy | Manawatu Engineering' }

export default function App() {
  const path = usePath(), { projects } = usePublishedProjects(), hasProjects = projects.length > 0
  useEffect(() => { document.title = titles[path] || 'Page not found | Manawatu Engineering'; document.querySelector('link[rel="canonical"]')?.setAttribute('href', `https://www.manawatuengineering.co.nz${path === '/' ? '/' : path}`); window.scrollTo({ top: 0, behavior: 'instant' }) }, [path])
  if (path.startsWith('/owner')) return <Suspense fallback={<div className="portal-loading">Loading owner portal…</div>}><OwnerPortal /></Suspense>
  let page
  switch (path) {
    case '/': page = <Home projects={projects} />; break
    case '/services': page = <Services />; break
    case '/about': page = <About />; break
    case '/contact': page = <Contact />; break
    case '/projects': page = hasProjects ? <Projects projects={projects} /> : <Home projects={projects} />; break
    case '/privacy': page = <Privacy />; break
    default: page = <NotFound />
  }
  return <Layout hasProjects={hasProjects}>{page}</Layout>
}
